import { Role } from '../profile/profile-model.service';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { UsersApiResult } from './users-search.service';
import { Profile, ProfileRole } from '../profile/profile-model.service';
import { MatPaginator } from '@angular/material/paginator';

export interface UserInGrid {
    name: string;
    email: string;
    role: Role;
    edit: string;
}

export class UsersDataSource implements DataSource<UserInGrid> {
    private rows: BehaviorSubject<UserInGrid[]>;
    private loadingSubject: BehaviorSubject<boolean>;
    private errorSubject: BehaviorSubject<boolean>;
    public hasDataReturned = true;
    public loading$;
    public error$;
    public total = 0;

    constructor() {
        this.rows = new BehaviorSubject<UserInGrid[]>([]);
        this.loadingSubject = new BehaviorSubject<boolean>(false);
        this.errorSubject = new BehaviorSubject<boolean>(false);
        this.loading$ = this.loadingSubject.asObservable();
        this.error$ = this.errorSubject.asObservable();
    }

    connect(): Observable<UserInGrid[]> {
        return this.rows.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.rows.complete();
        this.loadingSubject.complete();
        this.errorSubject.complete();
    }

    loadUsers(role: Role, usersList: Observable<UsersApiResult>, paginator?: MatPaginator): Observable<UsersApiResult> {
        this.loadingSubject.next(true);
        const observable = usersList.pipe(
            finalize(() => { this.loadingSubject.next(false); })
        );
        observable.subscribe(
            (result: UsersApiResult) => {
                const rows: UserInGrid[] = [];
                this.total = result.total;
                const users: Profile[] = result.profiles || [];
                users.forEach((user: Profile) => {
                    const rowObject = {
                        name: user.userName,
                        email: user.token,
                        role: role,
                        edit: user.token
                    } as UserInGrid;
                    rows.push(rowObject);
                });
                this.rows.next(rows);
                paginator && (paginator.length = this.total);
            },
            (error: any) => {
                this.rows.next([]);
                this.loadingSubject.next(false);
                this.errorSubject.next(error.status !== 400);
            }
        );
        return observable;
    }

    totalRecords(): number {
        return this.total;
    }

    clear() {
        this.rows.next([]);
        this.total = 0;
        this.errorSubject.next(false);
    }

}
